/******************************************************
 *                  Open-iti export
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("CoursesSpecialesCtrlParent", ["$scope", "CoursesSpecialesService", "Utils", "$uibModal", "toastr", "$location",
		function ($scope, CoursesSpecialesService, Utils, $uibModal, toastr, $location) {

		var deleteModal;
		$scope.data = {};

		/**
         * Ouvrir la modal de suppression d'une course
         */
		$scope.openDeleteModal = function (data) {
			$scope.data.courseDelete = data;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		/**
         * Supprimer une course
         * @param course
         */
		$scope.deleteCourseSpeciale = function (course) {
			CoursesSpecialesService.deleteCourse(course).then(() => {
				toastr.success(course.libelle + " a bien été supprimée.", "Course spéciale supprimée");
				deleteModal.close();
				$scope.refreshCoursesSpeciales();
				$location.path("e-iti/course-speciale");

			}).catch((error) => {
				const data = error.data;
				var errorMessage = "Problème lors de la suppression de la course.";
				if (data !== undefined && data.message) {
					errorMessage += data.message;
				}
				toastr.error(errorMessage, "Erreur");
			});
		};



	}]);
